import React from 'react';

import { STATE_COLORS } from './constants';
import { StateLozengeStyles as S } from './styles';

const KEY_TO_STYLE = {
  primary: S.Primary,
  success: S.Success,
  warning: S.Warning,
  neutral: S.Neutral
};

const StateLozenge = ({ state, color }) => {
  const key = color || STATE_COLORS[state] || 'neutral';
  const Wrap = KEY_TO_STYLE[key] || S.Neutral;
  return <Wrap>{state}</Wrap>;
};

export default StateLozenge;
